<template>
  <el-container>
    <Menu :activeIndex='activeIndex'></Menu>
    <el-container>
      <el-header>
        <h2>留言管理</h2>
      </el-header>
      <el-container style="border:10px solid #E9EEF3;">
        <!--<el-header height="auto">

        </el-header>-->
        <el-container>
          <el-aside width="310px" style="background:#E9EEF3;padding:10px 0;">
            <div class='editConpon clearfix'>
              <div class='class_row'>
                <span class="noreadNum" v-if="coursenoreadNum>0" v-text="coursenoreadNum"></span>
              </div>
              课程：
              <el-select v-model="currentId" placeholder="请选择" @change='changeCourse'>
                <el-option v-for="(item,index) in courseList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
<!--              <el-pagination style="background:#fff;" :page-size="9" @current-change="courseCurrentChange"
                             :current-page.sync="coursePage" layout="prev, pager, next"
                             :total="courseTotal"></el-pagination>-->
            </div>

            <el-table :data="classList" ref='singleTable' @current-change="handleRowChange" highlight-current-row
                      style="width: 100%;" :stripe="true" :border='true'
                      :default-sort="{prop: 'date', order: 'descending'}">
              <el-table-column type="index" width="20"></el-table-column>
              <el-table-column label="课时" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div class='class_row'>
                    <span v-text="scope.row.title"></span>
                    <i class="el-icon-zoom-in" @click="showLessonDetail(scope.row.id)"></i>
                    <span v-if="scope.row.notreadcount>0" class="noreadNum" v-text="scope.row.notreadcount"></span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination style="background:#fff;" :page-size="9" @current-change="handleCurrentChange"
                           :current-page.sync="currentPage" layout="prev, pager, next"
                           :total="dataTotal"></el-pagination>
          </el-aside>
          <el-main style="background:#E9EEF3;padding:10px;padding-right:0;">
            <div class="compart">
              <div class='com_item clearfix' v-for="(item,index) in comData" :key="index">
                <div class='left'>
                  <img :src="item.headurl"/>
                  <img v-if="item.isread==0" class='new_sign' src="../../static/img/new.png"/>
                </div>
                <div class='right'>
                  <div class="bt">
                    <span class='_name cutWord' v-text="item.nickname"></span>
                    <p>
                      <i class="_read noread" style="color:#17a81b;" v-if="item.isshow==0"
                         v-on:click="changeShow(item.id,index,1)">点击显示</i>
                      <i class="_read noread" v-if="item.isshow==1" v-on:click="changeShow(item.id,index,0)">点击隐藏</i>
                      <i class="_read noread" v-if="item.isread==0" v-on:click="changeRead(item.id,index)">标为已读</i>
                      <i class="_read" v-if="item.isread==1">已读</i>
                      <i class="iconfont icon-dianzan_kuai"></i>{{item.zancount}}
                      <i class="editcom el-icon-edit" v-on:click="addAuthorCom(item.id)"></i>
                      <i class="el-icon-upload2 upTop" v-on:click="goTop(item)"
                         style="font-size:18px;font-weight:600;margin-left:5px;"></i>
                      <i class="delcom el-icon-delete" v-on:click="delCom(item.id)"></i>
                    </p>
                  </div>
                  <div class='com_con' style="margin-bottom:1px;" v-text="item.content"></div>
                  <div v-for="(list,num) in item.replys">
                    <div class="bt" style="line-height:20px;">
                      <span class='_name' style="border-left:2px solid #17a81b;display:inline;">作者回复</span>
                      <span class='_del' v-on:click="delAuthorcom(list.id)">删除</span>
                    </div>
                    <div class='com_con' v-html="list.content"></div>
                  </div>
                  <div class="addCom" v-if="editId==item.id">
                    <div class="con">
                      <!--<p v-text="talkmsg"></p>-->
                      <!--<textarea class="editbox" placeholder="说点什么吧。。。" v-model="talkmsg"></textarea>-->
                      <vue-editor v-model="talkmsg" useCustomImageHandler @imageAdded="handleImageAdded"
                                  :editorToolbar="customToolbar"></vue-editor>
                    </div>
                    <div class='sendBtn' v-on:click="sendCom(item.id,item.openid,item.nickname,index)">
                      <span>发送</span>
                    </div>
                  </div>

                </div>
              </div>
              <div class='nocom' v-if="comData.length==0">暂无评论</div>
              <el-pagination style="background:#fff;" :page-size="20" @current-change="comCurrentChange"
                             :current-page.sync="comPage" layout="prev, pager, next" :total="comTotal"></el-pagination>
            </div>
          </el-main>
          <el-dialog title="课时内容查看" :visible.sync="lessonFormVisible" >
            <el-form :model="lessonsform">
              <el-form-item label="标题" :label-width="formLabelWidth">
                <el-input v-model="lessonsform.title" auto-complete="off" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="序列" :label-width="formLabelWidth">
                <el-input v-model="lessonsform.sort" auto-complete="off" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="简介" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="lessonsform.profile" autosize auto-complete="off" :disabled="true"></el-input>
              </el-form-item>
              <div class="_detail">
                <h2>课程详情</h2>
                <div v-for="(item,index) in conBox" style="position:relative;">
                  <el-form-item label="序号" :label-width="formLabelWidth">
                    <el-input v-model="item.sort" auto-complete="off" :disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item label="英文原文" :label-width="formLabelWidth">
                    <!--<vue-editor v-model="item.en_content"  :disabled="true"></vue-editor>-->
                    <div v-html="item.en_content"></div>
                  </el-form-item>
                  <el-form-item label="点我展开" :label-width="formLabelWidth">
                    <!--<vue-editor v-model="item.ch_content" :disabled="true"></vue-editor>-->
                    <div v-html="item.ch_content"></div>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </el-dialog>
        </el-container>
      </el-container>
      <el-footer>Copyright &copy; Soren经济学人 技术支持 ：
        <a href="#">苏州西西弗斯商务信息咨询有限公司</a>
      </el-footer>
    </el-container>

  </el-container>

</template>

<script>
    import {VueEditor} from "vue2-editor";

    export default {
        data() {
            return {
                coursePage: 1,
                courseTotal: 0,
                activeIndex: "7",
                courseList: [], //
                classList: [],
                currentclassIndex: 0,
                dataTotal: 0,
                comTotal: 0,
                currentId: '',
                currentPage: 1,
                comPage: 1,
                comData: [],
                currentRow: null,
                talkmsg: '',
                editId: '',
                classId: '',
                topnum: 0,
                customToolbar: [
                    ["bold", "italic", "underline", "strike"],
                    ["image", 'link'],
                    [{
                        color: []
                    }, {
                        background: []
                    }],
                    [{
                        font: []
                    }],
                    [{
                        align: []
                    }],
                    [{
                        header: 1
                    }, {
                        header: 2
                    }],
                    [{
                        header: [1, 2, 3, 4, 5, 6, false]
                    }],
                    [{
                        size: ["small", false, "large", "huge"]
                    }]
                ],
                classTitle: '',
                coursenoreadNum: 0,
                lessonFormVisible: false,
                lessonsform: {
                    author: "",
                    content: "",
                    lessonDetail: [],
                    courseid: "",
                    id: "",
                    name: "",
                    profile: "",
                    sort: "",
                    title: "",
                    mark: 'xueqiu'
                },
                conBox: [],
                formLabelWidth: "120px",
            };
        },
        created() {
            this.getData()
        },
        updated: function () {

        },
        components: {
            VueEditor
        },
        methods: {
            showLessonDetail: function (lessonId) {
                let self = this;
                self.lessonFormVisible = true;
                self.axios.post('/lessons/one', {
                    id: lessonId,
                    mark: 'xueqiu'
                }).then(function(response) {
                    if(response.data.code == "600") {
                        self.lessonsform = response.data.data;
                        self.conBox = self.lessonsform.lessonDetail;
                    }
                })
            },
            delAuthorcom: function (id) {
                var that = this;
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.axios.post('/reply/delete', {
                        id: id
                    })
                        .then(function (response) {
                            if (response.data.code == "600") {
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                var timer = setInterval(function () {
                                    that.getComList(that.classId);
                                    clearInterval(timer);
                                }, 100);
                            } else if (response.data.code == "400") {
                                that.$message({
                                    type: "error",
                                    message: "操作失败"
                                });
                            }
                        })
                        .catch(function (error) {
                            //console.log(error);
                        });
                })

            },
            handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
                var self = this;
                //1. 创建formData 利用AXIOS传递
                let formData = new FormData();
                formData.append("file", file);
                let config = {
                    "Content-Type": "multipart/form-data"
                };
                let var_this = this;
                self.axios.post("/file/uploadLogo", formData, config)
                    .then(function (result) {
                        //console.log(result);
                        let url = result.data.data; // Get url from response

                        Editor.insertEmbed(cursorLocation, "image", url);
                        resetUploader();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            goTop: function (item) {
                var that = this;
                that.axios.post('/comment/add', {
                    istop: that.topnum + 1,
                    id: item.id
                })
                    .then((response) => {
                        if (response.data.code == 600) {
                            var timer = setInterval(function () {
                                that.getComList(that.classId);
                                clearInterval(timer);
                            }, 100);
                        }

                    }).then((result) => {

                });
            },
            changeCourse: function (val) {
                var that = this;
                that.currentId = val;
                that.currentPage = 1;
                that.getclassData(1);
            },
            changeRead: function (id, index) {
                var that = this;
                that.axios.post('/comment/update', {
                    id: id,
                    isread: 1
                })
                    .then(function (response) {
                        console.log(response);
                        if (response.data.code == "600") {
                            that.coursenoreadNum--;
                            that.comData[index].isread = 1;
                            that.currentRow.notreadcount--;
                        } else if (response.data.code == "400") {
                            that.$message({
                                type: "error",
                                message: "操作失败"
                            });
                        }
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            },
            changeShow: function (id, index, showState) {//显示/隐藏评论
                var that = this;
                that.axios.post('/comment/update', {
                    id: id,
                    isshow: showState
                })
                    .then(function (response) {
                        if (response.data.code == "600") {
                            that.comData[index].isshow = showState;
                            that.$message({
                                type: "success",
                                message: "修改成功"
                            });
                        } else if (response.data.code == "400") {
                            that.$message({
                                type: "error",
                                message: "操作失败"
                            });
                        }
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            },
            delCom: function (comid) { //删除评论
                var that = this;
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.axios.post('/comment/delete', {
                        id: comid
                    })
                        .then(function (response) {
                            if (response.data.code == "600") {
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                var timer = setInterval(function () {
                                    that.getComList(that.classId);
                                    clearInterval(timer);
                                }, 100);
                            } else if (response.data.code == "400") {
                                that.$message({
                                    type: "error",
                                    message: "操作失败"
                                });
                            }
                        })
                        .catch(function (error) {
                            //console.log(error);
                        });

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            courseCurrentChange: function () {
                this.getData()
            },
            sendCom: function (val, openid, nickname, index) {
                var that = this;
                var re = new RegExp("^[ ]+$");
                if (that.talkmsg == "" || re.test(that.talkmsg) == true) {
                    that.$message({
                        type: "error",
                        message: "评论内容不能为空"
                    });
                } else {
                    that.axios.post('/reply/add', {
                        commentid: val,
                        content: that.talkmsg
                    })
                        .then(function (response) {
                            if (response.data.code == "600") {
                                that.talkmsg = '';
                                that.editId = '';
                                that.$message({
                                    type: 'success',
                                    message: '评论成功!'
                                });
                                var timer = setInterval(function () {
                                    that.getComList(that.classId);
                                    clearInterval(timer);
                                }, 100);
                                var timer2 = setInterval(function () {
                                    that.sendTip(openid, nickname, val, index)
                                    clearInterval(timer2);
                                }, 300);
                            } else if (response.data.code == "400") {
                                that.$message({
                                    type: "error",
                                    message: "操作失败"
                                });
                            }
                        })
                        .catch(function (error) {
                            //console.log(error);
                        });
                }
            },
            addAuthorCom: function (val) {
                var that = this;
                that.editId = val;
            },
            handleRowChange(val) {
                this.comPage = 1;
                this.currentRow = val;
                this.getComList(val.id);
                this.classId = val.id;
                this.classTitle = val.title;
                console.log(this.currentRow);
            },
            showClassList: function (index, id) {
                var that = this;
                that.currentclassIndex = index;
                that.currentId = id;
                that.currentPage = 1;
                that.getclassData(1);
            },
            getData() {
                var self = this;
                self.loading = true;
                self.axios.post('/course/list', {
                    mark: localStorage.getItem("mark"),
                    page: self.courseCurrentChange
                })
                    .then(function (response) {
                        if (response.data.code == "600") {
                            console.log(response.data);
                            self.courseTotal = response.data.dataTotal;
                            self.courseList = response.data.data;
                            self.currentId = response.data.data[3].id;

                            self.getclassData(1);
                        } else if (response.data.code == "400") {
                            self.$message({
                                type: "error",
                                message: "操作失败"
                            });
                        }
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            },
            getclassData(page) {
                var self = this;
                self.loading = true;
                self.axios.post('/lessons/getLessonList', {
                    mark: localStorage.getItem("mark"),
                    page: page,
                    courseid: self.currentId
                })
                    .then(function (response) {
                        if (response.data.code == "600") {
                            console.log(response)
                            self.classList = response.data.data;
                            self.dataTotal = response.data.dataTotal;
                            self.$refs.singleTable.setCurrentRow(response.data.data[0]);
                            self.coursenoreadNum = response.data.extend;
                        } else if (response.data.code == "400") {
                            self.$message({
                                type: "error",
                                message: "操作失败"
                            });
                        }
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            },
            handleCurrentChange: function (val) {
                this.getclassData(val);
            },
            getComList: function (classid) {
                var that = this;
                var userinfo = JSON.parse(localStorage.getItem("sorenuserinfo"));
                that.axios.post('/comment/list', {
                    lessionid: classid,
                    page: that.comPage
                })
                    .then((response) => {
                        if (response.data.code == 600) {
                            that.comData = response.data.data;
                            that.comTotal = response.data.dataTotal;
                            if (that.comPage == 1 && that.comTotal > 0) {
                                that.topnum = Math.floor(that.comData[0].istop);
                            }
                        }

                    }).then((result) => {

                });
            },
            comCurrentChange: function (val) {
                this.getComList(this.classId);
            },
            sendTip: function (id, nickname, val, index) {
                var self = this;
                var _url = 'https://uni.guanqimiao.cn/pages/my/guide?courseid=' + self.currentId;
                self.axios.post('/wxtool/getAccess_Token?mark=xueqiu').then(function (response) {
                    if (response.data.code == "600") {
                        self.axios.post('https://soren.guanqimiao.cn/Comment/pushMessage', {
                            "classTitle": self.classTitle,
                            "openid": id,
                            "currentId": self.currentId,
                            "nickname": nickname,
                            "lessonsid": self.currentRow.id
                        })
                            .then(function (res) {
                                self.$message({
                                    type: "success",
                                    message: res.data.msg
                                });
                                if (res.data.code == 600) {
                                    var timer2 = setInterval(function () {
                                        self.changeShow(val, index, 1)
                                        clearInterval(timer2);
                                    }, 300);
                                }

                            })
                            .catch(function (error) {

                            });
                        /*self.axios.post("https://api.weixin.qq.com/cgi-bin/message/template/send?access_token="+response.data.data,{
                          "touser":id,
                          "template_id":"rid-A7jLUAzNb9lUS-8eALKRslgie9rXWBjnUwLwylQ",
                          "url":_url,
                          "topcolor":"#FF0000",
                          "data":{
                            "first":{
                              "value":'老师对您的作业进行了反馈，点击查看～'
                            },
                            "keyword1":{
                              "value":self.classTitle,
                              "color":"#173177"
                            },
                            "keyword2": {
                              "value":nickname
                            },
                            "remark":{
                              "value":'日拱一卒，功不唐捐。'
                            }
                          }
                        })
                        .then(function(res) {
                          console.log(res);
                          self.$message({
                            type: "success",
                            message: "发送成功"
                          });
                        })
                        .catch(function(error) {

                        });*/
                    } else if (response.data.code == "400") {
                        self.$message({
                            type: "error",
                            message: "操作失败"
                        });
                    } else {

                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    };
</script>
<style scoped="scoped">
  .editConpon {
    background: #fff;
    padding: 10px;
    margin-bottom: 10px;
  }

  .editConpon .box_item {
    float: left;
    width: 200px;
    height: 55px;
    border: 1px solid #ccc;
    margin-right: 10px;
    padding: 5px 2px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .editConpon .box_item.cur {
    border-color: #67C23A;
  }

  .editConpon .box_item img {
    float: left;
    height: 100%;
    max-width: 80px;
  }

  .editConpon .box_item .right {
    float: left;
    width: 150px;
    line-height: 20px;
    font-size: 12px;
    padding-left: 2px;
    box-sizing: border-box;
    padding-top: 3px;
  }

  .clearfix:after,
  #container:after {
    content: "\0020";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden
  }

  .classImg {
    display: block;
    width: 100px;
  }

  .compart {
    background: #fff;
    padding: 10px;
  }

  .compart .com_item {
    border-bottom: 1px solid #ebeef5;
    position: relative;
    padding-bottom: 5px;
  }

  .compart .com_item .left {
    position: absolute;
    left: 10px;
    top: 5px;
    width: 62px;
    padding: 1px 0;
  }

  .compart .com_item .left img {
    display: block;
    width: 50px;
    border-radius: 2px;
    margin: 0 auto;
  }

  .compart .com_item .left .new_sign {
    width: 20px;
    position: absolute;
    right: -6px;
    top: -6px;
  }

  .compart .com_item .right {
    width: 100%;
    padding-left: 82px;
    box-sizing: border-box;
    padding-right: 10px;
  }

  .compart .com_item .right .bt {
    line-height: 26px;
    color: #747273;
    font-size: 14px;
    padding: 2px 0;
    position: relative;
  }

  .compart .right .bt ._name {
    display: block;
    width: 75%;
    padding-left: 10px;
  }

  .compart .right .bt ._del {
    color: #d00;
    margin-left: 10px;
    cursor: pointer;
  }

  .compart .right .com_con {
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    color: #2f2d2e;
    padding: 0 20px 0 10px;
  }

  .compart .right .com_con /deep/ p {
    margin: 0;
  }

  .compart .right .com_con /deep/ img {
    display: block;
    max-width: 100%;
    max-height: 150px;
  }

  .compart .com_item .right .bt p {
    position: absolute;
    right: 0;
    top: 3px;
    line-height: 20px;
    margin: 0;
  }

  .compart .bt p .iconfont {
    margin-right: 0.1rem;
  }

  .compart .com_item .right .bt .delcom,
  .compart .com_item .right .bt .editcom {
    font-size: 16px;
    margin-left: 10px;
    color: #747273;
  }

  .compart .com_item .right .bt .delcom:hover {
    cursor: pointer;
    color: #d00;
  }

  .compart .com_item .right .bt .upTop:hover {
    cursor: pointer;
    color: #67C23A;
  }

  .compart .com_item .right .bt .editcom:hover {
    cursor: pointer;
    color: #67C23A;
  }

  .compart .com_item .right .bt ._read {
    font-style: normal;
    margin-right: 10px;
  }

  .compart .com_item .right .bt ._read.noread {
    color: #d00;
    cursor: pointer;
  }

  .compart .com_item .addCom {
    padding-right: 100px;
    position: relative;
    background: #67C23A;
  }

  .compart .com_item .addCom .sendBtn {
    position: absolute;
    width: 100px;
    text-align: center;
    line-height: 34px;
    right: 0;
    top: 0;
    height: 100%;
    cursor: pointer;
  }

  .compart .com_item .addCom .sendBtn span {
    position: absolute;
    width: 100px;
    line-height: 60px;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    color: #fff;
    height: 60px;
  }

  .compart .com_item .addCom .con {
    position: relative;
    background: #fff;
  }

  .compart .com_item .addCom p {
    min-height: 34px;
    padding: 5px;
    font-size: 14px;
    line-height: 24px;
    margin: 0;
    box-sizing: border-box;
    opacity: 0;
  }

  .compart .com_item .addCom .editbox {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 5px;
    font-size: 14px;
    line-height: 24px;
    margin: 0;
    box-sizing: border-box;
    resize: none;
    overflow-y: hidden;
    border: 1px solid #DCDFE6;
  }

  .compart .nocom {
    text-align: center;
    line-height: 300px;
  }

  .class_row {
    position: relative;
  }

  .class_row .noreadNum {
    position: absolute;
    height: 17px;
    min-width: 30px;
    background: #d43735;
    color: #fff;
    right: 0px;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
    border-radius: 10px;
    padding: 0;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/StayWord.vue